import { MaintenanceAspectResolverBase } from './maintenance-aspect.resolver.base';
import { MaintenanceAspectService } from './maintenance-aspect.service';
import { Injectable } from '@angular/core';



@Injectable({ providedIn: 'root' })
export class MaintenanceAspectResolver extends MaintenanceAspectResolverBase {

  constructor(protected service: MaintenanceAspectService) {
    super(service);
  }
}



